import { TagState } from "./types";

export const tagStateInit: TagState = {
  search: {},
};

export default tagStateInit;
